/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudPairingDeviceCodeVlrOrgSecretSpec } from './cloudPairingDeviceCodeVlrOrgSecretSpec';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { IrrGatewayCertSecretSpec } from './irrGatewayCertSecretSpec';
import { VlrOrgSecretsUpsertSpecDeployment } from './vlrOrgSecretsUpsertSpecDeployment';
import { CloudPairingClientSecretVlrOrgSecretSpec } from './cloudPairingClientSecretVlrOrgSecretSpec';
import { CarbonBlackVlrOrgSecretSpec } from './carbonBlackVlrOrgSecretSpec';
import { VlcrVlrOrgSecretSpec } from './vlcrVlrOrgSecretSpec';
import { VcdsOAuthAppVlrOrgSecretSpec } from './vcdsOAuthAppVlrOrgSecretSpec';
import { VmcfsSddcVmcVlrOrgSecretSpec } from './vmcfsSddcVmcVlrOrgSecretSpec';
import { CrowdstrikeVlrOrgSecretSpec } from './crowdstrikeVlrOrgSecretSpec';
import { SddcVmcVlrOrgSecretSpec } from './sddcVmcVlrOrgSecretSpec';
import { SecretManagerAccount } from './secretManagerAccount';


export interface VlrOrgSecretsUpsertSpec { 
    vlr_org_id: string;
    cloud_provider: CloudProvidersEnum;
    cloud_account_type: SecretManagerAccount;
    carbon_black?: CarbonBlackVlrOrgSecretSpec;
    carbon_black_byo?: CarbonBlackVlrOrgSecretSpec;
    cloud_pairing_client_secret?: CloudPairingClientSecretVlrOrgSecretSpec;
    cloud_pairing_device_code?: CloudPairingDeviceCodeVlrOrgSecretSpec;
    crowdstrike?: CrowdstrikeVlrOrgSecretSpec;
    deployment?: VlrOrgSecretsUpsertSpecDeployment;
    sddc_vmc?: SddcVmcVlrOrgSecretSpec;
    vlcr?: VlcrVlrOrgSecretSpec;
    vmcfs_sddc_vmc?: VmcfsSddcVmcVlrOrgSecretSpec;
    vcds?: VcdsOAuthAppVlrOrgSecretSpec;
    irr_gateway_cert?: IrrGatewayCertSecretSpec;
}
export namespace VlrOrgSecretsUpsertSpec {
}


